import { render, staticRenderFns } from "./ProjectSteps.vue?vue&type=template&id=270750ae&scoped=true&"
import script from "./ProjectSteps.vue?vue&type=script&lang=js&"
export * from "./ProjectSteps.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSteps.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ProjectSteps.vue?vue&type=style&index=1&id=270750ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270750ae",
  null
  
)

export default component.exports